export default __webpack_public_path__ + "static/media/flurryofblows.d2137bfb.png";